<template>
  <div class="wrapper" :class="{'sidebar-shown': displaySidebar, 'sidebar-open': sidebarOpen}">
    <sidebar active="4" @openSidebar="sidebarOpen = true" @closeSidebar="sidebarOpen = false" @saveProgress="showSaveProgress = true"/>
    <main id="main" class="content has-sidebar">
      <app-header :back="back"></app-header>
      <header class="page">
        <h1 class="title">Inoculation</h1>
        <p class="subtitle">Choose an inoculation option</p>
      </header>
      <form class="form">
        <div class="form-row">
          <drop-down :items="options" :selected="options[inoculationOption]" @changed="inoculationOption = $event"></drop-down>
        </div>
        <div class="form-row">
          <div class="inoculation-content">
            <h4 class="heading-inoculation" v-text="optionMeta[inoculationOption].title"></h4>
            <p v-text="optionMeta[inoculationOption].description"></p>
          </div>
        </div>
        <div class="form-row">
          <button class="btn btn-primary has-arrow" @click.prevent="$router.push({ name: 'summary' })">Next</button>
        </div>
      </form>
    </main>
    <save-progress :shown="showSaveProgress" @close="showSaveProgress = false" />
  </div>
</template>

<script>
import Sidebar from '@/components/Sidebar'
import Dropdown from '@/components/Dropdown'
import Header from '@/components/Header'
import SaveProgress from '@/components/SaveProgress'
export default {
  components: {
    'sidebar': Sidebar,
    'drop-down': Dropdown,
    'app-header': Header,
    'save-progress': SaveProgress
  },
  data () {
    return {
      back: 'species',
      displaySidebar: true,
      sidebarOpen: false,
      showSaveProgress: false,
      options: [
        'No inoculant',
        'Inoculant sent separately'
      ],
      optionMeta: [
        {
          title: 'Forego inoculating',
          description: 'If ground has previously grown the legume crops in your mix you may forego inoculating. Legumes can grow without inoculant, but will be slower to fixate nitrogen and may not perform to their full potential.'
        },
        {
          title: '+$.07/lb. of legume seed',
          description: 'Inoculant applied at time of planting will be more effective than if it is mixed with seed multiple days prior to planting. Powder inoculants are easily applied to seed in the planter.'
        },
        {
          title: '+$.15/lb. of legume seed',
          description: 'Choose this option only if you will be planting a maximum of 3 days after ordering the seed.'
        }
      ]
    }
  },
  computed: {
    inoculationOption: {
      get () {
        return this.$store.state.formData.inoculantOption
      },
      set (value) {
        this.$store.commit('updateInoculantOption', value)
        this.$emit('updateTotals') // bubble up to App.vue
      }
    }
  }
}
</script>

<style lang="scss">
  .inoculation-content {
    background: rgba($color-medium-green, 0.5);
    border-radius: 3px;
    text-align: left;

    .heading-inoculation {
      background: rgba($color-medium-green, 0.5);
      color: $color-white;
      font-size: 14px;
      letter-spacing: 2px;
      text-transform: uppercase;
      font-weight: 600;
      padding: 20px 30px;
      border-radius: 3px 3px 0 0;
    }

    >p {
      color: $color-white;
      line-height: 24px;
      font-weight: 600;
      padding: 15px 30px 20px;
    }
  }
</style>
